import { useEffect, useState } from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import styles from "./styles.module.scss"
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons"

const PasswordChecklist=({ value, onSetAllRulesMatch, passwordsMatch })=> {
  const [specialChar, setSpecialChar]=useState(false) // special character
  const [upperCase, setUpperCase]=useState(false) // uppercase letter
  const [lowerCase, setLowerCase]=useState(false) // lowercase letter
  const [number, setNumber]=useState(false) // number
  const [minLength, setMinLength]=useState(false) // min 8 characters

  const RULES = [ 
    {
      id: "specialChar",
      message: "Password has special character",
      value: specialChar
    },
    {
      id: "upperCase",
      message: "Password has capital letter",
      value: upperCase
    },
    {
      id: "lowerCase",
      message: "Password has lowercase letter",
      value: lowerCase
    },
    {
      id: "number",
      message: "Password has a number",
      value: number
    },
    {
      id: "minLength",
      message: "Password has 8 characters or more",
      value: minLength
    },
    {
      id: "passwordsMatch",
      message: "Passwords match",
      value: passwordsMatch
    }
  ]

  useEffect(()=> {
    setSpecialChar(() => /[ !@#$%\^&*]/g.test(value)) // eslint-disable-line
    setUpperCase(() => value?.toLowerCase() !== value)
    setLowerCase(() => value?.toUpperCase() !== value)
    setNumber(() => /\d/.test(value))
    setMinLength(() => value?.length >= 8)
    onSetAllRulesMatch(() => (specialChar && upperCase && lowerCase && number && minLength && passwordsMatch))
  }, [lowerCase, minLength, number, onSetAllRulesMatch, value, specialChar, upperCase, passwordsMatch])

  return (
    <div className={styles.rulesContainer}>
      {RULES.map((rule, key)=> {
        return (
          <div key={key}>
            {rule.value ? <span className={styles.ok}><FontAwesomeIcon icon={faCheckCircle} /></span> : <span className={styles.error}><FontAwesomeIcon icon={faExclamationCircle} /></span>}
            <p>{rule.message}</p>
          </div>
        )
      })}
    </div>
  )
}

export default PasswordChecklist